import { message } from 'antd';
import React from 'react';
import { createRoot } from 'react-dom/client';
import moment from 'moment';
import 'moment/locale/es';
import App from './app';
import * as serviceWorker from './serviceWorker';
import Backend, { BackendContext } from './shared/services/Backend';

moment.locale('es');

try {
    const momentAntd = require('antd/node_modules/moment');
    require('antd/node_modules/moment/locale/es');
    momentAntd.locale('es');
} catch (e) {
    console.log('No nested moment in antd');
}

try {
    const momentRc = require('rc-calendar/node_modules/moment');
    require('rc-calendar/node_modules/moment/locale/es');
    momentRc.locale('es');
} catch (e) {
    console.log('No nested moment in rc-calendar');
}

message.config({
    duration: 2,
    maxCount: 1,
});

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) si usas TypeScript
root.render(
    <BackendContext.Provider value={Backend.getInstance()}>
        <App />
    </BackendContext.Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
